import { useState } from 'react'
import { projects } from '../data/projects'
import ProjectCard from './ProjectCard'
import ProjectModal from './ProjectModal'
import useInView from '../lib/useInView'

export default function Projects() {
  const [selected, setSelected] = useState(null)
  const [ref, visible] = useInView()

  return (
    <section id="projects" className="section-padding bg-[#0a0a0a]">
      <div className="section-container" ref={ref}>

        <div className={`mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="section-label">// 02. projects</span>
          <h2 className="section-heading">Things I've Built</h2>
          <div className="section-divider" />
          <p className="text-[#94a3b8] max-w-xl">
            A selection of projects spanning distributed systems, API design, and developer tooling.
            Click any card for the full technical breakdown.
          </p>
        </div>

        <div
          className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-700 delay-200 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {projects.map((project, i) => (
            <ProjectCard
              key={project.id}
              project={project}
              index={i}
              onClick={setSelected}
            />
          ))}
        </div>
      </div>

      {selected && (
        <ProjectModal project={selected} onClose={() => setSelected(null)} />
      )}
    </section>
  )
}
